// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2w2yD","amount":"Amount_amount__3i1Tp","tip":"Amount_tip__aInxy","tipHeader":"Amount_tipHeader__1vIhM","tipsWrap":"Amount_tipsWrap__1UPO1"};